import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BasketBuilderPage } from './basket-builder.page';

import { PageNotFoundComponent } from '@app/shared/page-not-found.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                component: BasketBuilderPage,
                pathMatch: 'full',
                data: { reuse: true }
            },
            {
                path: 'kitchen-units/unit/:code',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'kitchen-units/:category',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'kitchen-units/:category/:subCategory',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'kitchen-units/:category/:subCategory/:details',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'kitchen-doors',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'appliances/:category',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'appliances/:category/:subCategory',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'appliances/:category/:subCategory/:details',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'sinks-and-taps/:category',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'sinks-and-taps/:category/:subCategory',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'sinks-and-taps/:category/:subCategory/:description',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'handles/:category',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'handles/:category/:details',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'accessories/:category',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'accessories/:category/:subcategory',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'accessories/:category/:subcategory/:details',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'laminate-worktops',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'wood-worktops',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'solid-surfaces/:category',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            {
                path: 'samples/door-samples',
                component: BasketBuilderPage,
                data: { reuse: true }
            },
            { path: '**', component: PageNotFoundComponent }
        ])
    ],
    exports: [RouterModule]
})
export class BasketBuilderRouting { }
